import Typography, { TypographyProps } from '@mui/material/Typography';
import React from 'react';

type TypeProps = TypographyProps<'div', {}>;

export function Title(props: any) {
  return (
    <>
      <TypeOcrH4 sx={{ mx: 4 }} align='center'>
        {props.children}
      </TypeOcrH4>
    </>
  );
}

export function TypeOcrB1(props: TypeProps) {
  return (
    <Typography
      component={'div'}
      variant='body1'
      className='ne-font'
      {...props}
    >
      {props.children}
    </Typography>
  );
}

export function TypeOcrB2(props: TypeProps) {
  return (
    <Typography
      component={'div'}
      variant='body2'
      className='ne-font'
      {...props}
    >
      {props.children}
    </Typography>
  );
}

export function TypeOcrH6(props: TypeProps) {
  return (
    <Typography component={'div'} variant='h6' className='ne-font' {...props}>
      {props.children}
    </Typography>
  );
}

export function TypeOcrH5(props: TypeProps) {
  return (
    <Typography component={'div'} variant='h5' className='ne-font' {...props}>
      {props.children}
    </Typography>
  );
}

export function TypeOcrH4(props: TypeProps) {
  return (
    <Typography component={'div'} variant='h4' className='ne-font' {...props}>
      {props.children}
    </Typography>
  );
}

export function TypeOcr(props: TypeProps) {
  return (
    <Typography component={'div'} className='ne-font' {...props}>
      {props.children}
    </Typography>
  );
}

export function TypeSubTitle(props: TypeProps) {
  return (
    <Typography
      component={'div'}
      variant='h4'
      className='ne-font'
      sx={{ mx: 0, my: 0 }}
      align='center'
      {...props}
    >
      {props.children}
    </Typography>
  );
}

export function BlogText(props: TypeProps) {
  return <p>{props.children}</p>;
}

export function BlogHead(props: TypeProps) {
  return (
    <Typography
      mt={4}
      mb={-1}
      component={'div'}
      variant='h4'
      className='ne-font'
      {...props}
    >
      {props.children}
    </Typography>
  );
}

export function BlogSubHead(props: TypeProps) {
  return (
    <Typography
      mt={4}
      mb={-1}
      component={'div'}
      variant='h5'
      className='ne-font'
      {...props}
    >
      {props.children}
    </Typography>
  );
}

export function BlogSubSubHead(props: TypeProps) {
  return (
    <Typography
      mt={4}
      mb={-1}
      component={'div'}
      variant='h6'
      className='ne-font'
      {...props}
    >
      {props.children}
    </Typography>
  );
}
